import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import Messaging from './Messaging';
import { jsx as _jsx } from "react/jsx-runtime";
const Banner = ({
  alertType,
  closable,
  langPath,
  onClose,
  showCta,
  redirectUrl
}) => {
  return /*#__PURE__*/_jsx(UIAlert, {
    "data-testid": "account-suspension-banner",
    "data-test-id": "account-suspension-banner",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: langPath.title
    }),
    type: alertType,
    closeable: closable,
    onClose: onClose,
    children: /*#__PURE__*/_jsx(Messaging, {
      langPath: langPath,
      showCta: showCta,
      redirectUrl: redirectUrl
    })
  });
};
Banner.propTypes = {
  alertType: PropTypes.oneOf(['danger', 'success', 'warning']).isRequired,
  showCta: PropTypes.bool.isRequired,
  redirectUrl: PropTypes.string,
  langPath: PropTypes.shape({
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    cta: PropTypes.string.isRequired
  }).isRequired,
  closable: PropTypes.bool.isRequired,
  onClose: PropTypes.func
};
export default Banner;